import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AbTestProvider from './components/AbTest';
import ErrorBoundary from './components/ErrorBoundary';
import { PublicRoutes } from './routes';
import { FeatureFlagsProvider } from './providers/feature-flags.provider';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <div className="App">
      <Router>
        <HelmetProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <FeatureFlagsProvider>
              <AbTestProvider>
                <ErrorBoundary>
                  <PublicRoutes/>
                </ErrorBoundary>
              </AbTestProvider>
            </FeatureFlagsProvider>
          </LocalizationProvider>
        </HelmetProvider>
      </Router>
      <ToastContainer/>
    </div>
  );
}

export default App;
